<template>
  <div class="pg-layout-menu-search" :style="searchStyle">
    <Input
      class="pg-layout-menu-search__input"
      size="medium"
      clearable
      placeholder="在这里输入您要搜索的菜单"
      prefix-icon="ivu-icon-icon-pg-serach"
      :value="searchVal"
      @focus="onFocus"
      @blur="onBlur"
      @input="onChange"
    />
    <Transition name="pg-layout-menu-search__list">
      <ul class="pg-layout-menu-search__list" v-show="searchListVisible">
        <li class="pg-layout-menu-search__list-place" v-show="title">{{ title }}</li>
        <li
          class="pg-layout-menu-search__list-item"
          v-for="router in searchList"
          :key="router.id"
          @mousedown="toRouter(router.id)"
        >
          {{ router.title }}
        </li>
      </ul>
    </Transition>
  </div>
</template>
<script setup>
import { Input } from 'element-ui'
import { ref, computed, getCurrentInstance } from 'vue'
import { get, post } from '../../../utils/index'

const emit = defineEmits(['on-select'])
const { proxy } = getCurrentInstance()

const searchList = ref([])
const getHistory = async () => {
  const [res] = await get('rest/ezcomp/navigator/queryUsuallyMenu', {}, { errorTip: null })
  if (res && res.code === 200) {
    searchList.value = res.data.map((im) => {
      return {
        id: im.id,
        title: im.name,
      }
    })
  }
}

const menuListNoTree = computed(() => proxy.$store.state.menuStore.menuListNoTree)
const searchVal = ref(null)
const onChange = (val) => {
  if (val) {
    searchList.value = menuListNoTree.value.filter((im) => {
      return im.title.includes(val) && (!im.children || im.children.length === 0)
    })
  } else {
    getHistory()
  }
  searchVal.value = val
}
const title = computed(() =>
  !searchVal.value ? '最近搜索' : searchList.value?.length === 0 ? '暂未查询到结果...' : ''
)

const toRouter = (id) => {
  post('rest/ezcomp/navigator/submitUsuallyMenu', { id }, { errorTip: null })
  emit('on-select', id)
}

const searchListVisible = ref(false)
const onFocus = () => {
  !searchVal.value && getHistory()
  searchListVisible.value = true
}
const onBlur = () => {
  searchListVisible.value = false
}
const searchStyle = computed(() => ({ width: searchListVisible.value ? '200px' : '' }))
</script>
<style lang="scss">
@import '../style/menu-search.scss';
</style>
